import React from "react";
import {
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  Button,
  Typography,
  Grid,
  TextField,
  InputAdornment
} from "@mui/material";
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import * as premiumApi from "../../api/premiumApi";
import ScrollToTopBtn from "../common/ScrollToTop";
import { withParams } from "../common/WithParams";
import { connect } from "react-redux";

class VintageByYearAdmin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      membership: "",
      year: "",
      vintagesByYear: [],
      page: 0,
      rowsPerPage: 100,
      sortDirection: "asc",
      searchQuery: "",
    };
  }

  async componentDidMount() {
    try {
      const user = this.props.signedinuser;
      const membership = this.props.params.org;
      const year = this.props.params.year;
      this.setState({ user, membership, year });
      const vintages = await premiumApi.getVintagesByYear(membership, year, 0);
      if (vintages) {
        this.setState({ vintagesByYear: vintages });
      }
    } catch (error) {
      console.log("Error in componentDidMount", error);
    }
  }

  handleChangePage = (_event, newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value, page: 0 });
  };

  compareBy = (key, direction) => {
    return function (a, b) {
      if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
      if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
      return 0;
    };
  };

  sortBy = (key) => {
    const { sortDirection, vintagesByYear } = this.state;
    const newDirection = sortDirection === "asc" ? "desc" : "asc";
    const sortedArray = [...vintagesByYear].sort(this.compareBy(key, newDirection));
    this.setState({ vintagesByYear: sortedArray, sortDirection: newDirection });
  };

  handleDownload = async () => {
    const { membership, year } = this.state;
    await premiumApi.getExcelFile(membership, year, 0, true);
  };

  handleSearch = (event) => {
    this.setState({ searchQuery: event.target.value });
  };

  render() {
    const { searchQuery, membership, vintagesByYear, year, page, rowsPerPage } = this.state;

    const layout = {
      width: "100%",
      paddingTop: 80,
    };

    const tableWrapper = {
      marginTop: "10px",
      overflow: "auto",
    };

    const headCell = {
      backgroundColor: "#eeeeee",
      fontWeight: "bold",
      fontSize: 16,
      cursor: "pointer",
    };

    const emptyPaper = {
      paddingTop: "45px",
      paddingLeft: "50px",
    };

    const linkStyle = {
      textDecoration: "none",
      color: "#673ab7",
    };
    const columns = [
      { id: "vismer", label: "", align: "center" },
      { id: "prizeYear", label: "ÅR" },
      { id: "companyName", label: "Bedrift" },
      {
        id: "repPrizes",
        label: "Rapportert beløp",
        align: "right",
        format: (value, row) =>
          row.repPercent > 0 && value === 0 ? "Ukjent" : value.toLocaleString("de-DE"),
      },
      {
        id: "repPercent",
        label: "Rapportert Andel i %",
        align: "right",
        format: (value) => value.toLocaleString("de-DE"),
      },
      {
        id: "ownedPrizes",
        label: "Eide beløp",
        align: "right",
        format: (value, row) =>
          row.ownedPercent > 0 && value === 0 ? "Ukjent" : value.toLocaleString("de-DE"),
      },
      {
        id: "ownedPercent",
        label: "Eide andel i %",
        align: "right",
        format: (value) => value.toLocaleString("de-DE"),
      },
    ];

    return (
      <React.Fragment>
        <Container maxWidth="lg">
          <main style={layout}>
            {/* Title */}
            <Typography variant="h5" sx={{ mb: 2 }}>
              Premier for {year}
            </Typography>

            <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>

              <Grid item>
                <TextField
                  placeholder="Søk"
                  variant="standard"
                  sx={{ width: "250px", backgroundColor: "white", borderRadius: 1 }}
                  value={searchQuery}
                  onChange={this.handleSearch}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<CloudDownloadIcon />}
                  onClick={this.handleDownload}
                  style={{ marginBottom: "16px" }}
                >
                  Vis i Excel
                </Button>
              </Grid>
            </Grid>

            <Paper>
              <div style={tableWrapper}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      {columns.map((column, index) => (
                        <TableCell
                          key={index}
                          align={column.align || "left"}
                          style={headCell}
                          onClick={() => this.sortBy(column.id)}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {vintagesByYear.length > 0 ? (
                      vintagesByYear
                        .filter(v =>
                          v.companyName.toLowerCase().includes(searchQuery.toLowerCase())
                        )
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((vintage, index) => (
                          <TableRow key={index} hover>
                            {columns.map((column, columnIndex) => {
                              const value = vintage[column.id];
                              if (column.id === "vismer") {
                                return (
                                  <TableCell
                                    key={columnIndex}
                                    align={column.align || "left"}
                                  >
                                    <Link
                                      to={`/premiumdetailadmin/${membership.toLowerCase()}/${vintage.companyId}/${vintage.prizeYear}`}
                                      style={linkStyle}
                                    >
                                      <Button
                                        variant="outlined"
                                        size="medium"
                                        color="primary"
                                      >
                                        <ArrowRightIcon />
                                        Vis
                                      </Button>
                                    </Link>
                                  </TableCell>
                                );
                              }
                              return (
                                <TableCell
                                  key={columnIndex}
                                  align={column.align || "left"}
                                >
                                  {column.format && typeof value === "number"
                                    ? column.format(value, vintage)
                                    : value}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={columns.length}>
                          <Typography style={emptyPaper}>Ingen treff</Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </div>
              <TablePagination
                rowsPerPageOptions={[10, 50, 100]}
                component="div"
                count={vintagesByYear.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={this.handleChangePage}
                onRowsPerPageChange={this.handleChangeRowsPerPage}
              />
            </Paper>
          </main>
        </Container>
        <ScrollToTopBtn />
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const signedinuser = state.signedinuserobject
    ? state.signedinuserobject.signedInUser
    : sessionStorage.getItem("token")
      ? JSON.parse(sessionStorage.getItem("token"))
      : [];

  return { signedinuser: signedinuser };
}

export default connect(mapStateToProps)(withParams(VintageByYearAdmin));